export const HOTJAR_ID = 5240667;
export const GOOGLE_ANALYTICS = "G-J4W91HKYYX";
export const TOKEN = "droomwork-client-token";
/* Opaque refresh token. Absent until the backend starts issuing token pairs;
   the refresh manager treats "no refresh token" as "session over", which is
   what keeps this shippable ahead of the backend work. */
export const REFRESH_TOKEN = "droomwork-client-refresh";
/* Access-token expiry as epoch ms, so we can refresh pre-emptively later
   without decoding the JWT on every request. */
export const ACCESS_TOKEN_EXPIRY = "droomwork-client-token-exp";

export const SIGNUP_HIRER_STEP_STORE = "droomwork-hirer-store";
export const KYB_STEP_STORE = "droomwork-kyb-store";

export const DEFAULT_PHOTO_URL = "https://res.cloudinary.com/droomwork/image/upload/v1614715606/fyd319ojzgxvzqlhgv9x.png";
